import { useQuery } from '@tanstack/react-query';
import { DashboardElementType } from 'tools/types';
import {
    ComponentSettings,
    contentSettingsToComponentProperties,
    ManageFiltersInitialDataResponse,
} from '@report-content';
import { reportAPI } from 'api/report';
import useReportContentSettings from 'components/report-content/hooks/useReportContentSettings';

export function useInternalReportFiltersInitialData(
    elementId: number,
    segmentValueId: number,
    elementType: DashboardElementType,
    segmentData?: any,
    componentSettings?: ComponentSettings,
) {
    const { settings: contentSettings } = useReportContentSettings(
        'view',
        elementId,
        segmentValueId,
        [],
        '',
        0,
        false,
        [],
        [],
        segmentData,
    );

    const { data: initialData, isLoading } = useQuery<ManageFiltersInitialDataResponse | null, Error>({
        queryKey: [
            'burstManageFiltersState',
            elementId,
            elementType,
            typeof componentSettings,
            contentSettings.measurement_time,
            contentSettings.segmentValueId,
        ],
        queryFn: () => {
            if (elementType != 'internal report' || !componentSettings) {
                return null;
            }
            return reportAPI.getComponentData(
                componentSettings,
                contentSettingsToComponentProperties(contentSettings),
                null,
            );
        },
    });

    return { initialData, contentSettings, isLoading };
}
